import { partnerAdminFetch } from '~/api/partnerAdminFetch';
import { CategoryType } from '../../types/resources/ServiceType';

type CategoryListType = {
  categories: CategoryType[];
};

export async function fetchCategories(signOut: () => void): Promise<CategoryListType> {
  const response = await partnerAdminFetch(
    '/partner_admins/categories',
    {
      method: 'GET',
    },
    signOut
  );

  if (!response.ok) {
    throw new Error(`${response.status} ${response.statusText}`);
  }

  return response.json();
}
